// heroData.js — Hero section configuration

import pic from '../Assets/home.jpg';
import pic1 from '../Assets/hero.jpg';
import pic2 from '../Assets/home1.jpeg';

const heroData = {
  title: 'Turning Your Property Dreams\nInto Reality.',
  subtitle: 'Plots, Villas, Apartments, And Rental Properties With Trusted Listings And Verified Sellers & Documentation.',
  search_placeholder: 'Search by city, location, property type…',

  bg_images: [pic1, pic, pic2],

  search_tabs: [
    { id: 'buy',  label: 'Buy'  },
    { id: 'rent', label: 'Rent' },
    // { id: 'sale', label: 'Sale' },
  ],

  quick_actions: [
    {
      id: 'buy',
      label: 'Buy Property',
      description: 'Find your perfect home from verified listings.',
      icon: 'home',
      url: '/properties?type=all',
      color: '#1565c0',
    },
    {
      id: 'sale',
      label: 'Sell Property',
      description: 'List and sell your property quickly.',
      icon: 'money',
      url: 'role?context=property',
      color: '#e65100',
    },
    {
      id: 'rent',
      label: 'Rent / Lease',
      description: 'Explore rental homes across top cities.',
      icon: 'key',
      url: '/properties?type=rent',
      color: '#6a1b9a',
    },
    {
      id: 'post',
      label: 'Post Property',
      description: 'Upload your property listing — 100% FREE.',
      icon: 'upload',
      url: '/role?context=property', // Step 1 → Role → Step 2 → Listing Type → /property/create
      color: '#2e7d32',
      is_free: true,
    },
    {
      id: 'project',
      label: 'Create Project',
      description: 'List your real estate development project.',
      icon: 'project',
      url: '/role?context=project',  // Step 1 → Role → /project/create (no listing type step)
      color: '#00695c',
    },
  ],

  free_banner: {
    lines: [
      'Upload Property — Absolutely FREE!',
      // 'No Commission. No Hidden Charges.',
      'Reach 10,000+ Buyers Instantly.',
    ],
  },

  nearby_properties_enabled: true,
  nearby_radius_km: 10,
};

export default heroData;